import axios from 'axios';
import { apiService } from './api';
import { DataProcessingJob, DataProcessingRequest } from '@/types/dataProcessing';

export const startDataProcessing = (request: DataProcessingRequest): Promise<DataProcessingJob> =>
  apiService.post<DataProcessingJob>('/v1/data-processing', request);

export const fetchDataProcessingStatus = (jobId: string, userEmail: string): Promise<DataProcessingJob> =>
  apiService.get<DataProcessingJob>(`/v1/data-processing/${encodeURIComponent(jobId)}`, {
    params: { user_email: userEmail },
  });

export const getDataProcessingErrorMessage = (error: unknown): string => {
  if (axios.isAxiosError(error)) {
    return error.response?.data?.message ?? error.message;
  }
  return 'Something went wrong with data processing. Please try again.';
};
